var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('h2',{staticClass:"text-h3 d-inline-block"},[_vm._v(" Zugriff nicht erlaubt ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }